import { render, staticRenderFns } from "./SwitchLiveBoxCustomer.vue?vue&type=template&id=20f24125"
import script from "./SwitchLiveBoxCustomer.vue?vue&type=script&lang=js"
export * from "./SwitchLiveBoxCustomer.vue?vue&type=script&lang=js"
import style0 from "./SwitchLiveBoxCustomer.vue?vue&type=style&index=0&id=20f24125&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports